import { Component, OnInit } from '@angular/core';
import {MatBottomSheet, MatBottomSheetRef} from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-network-check',
  templateUrl: './network-check.component.html',
  styleUrls: ['./network-check.component.scss']
})
export class NetworkCheckComponent implements OnInit {

  

  constructor(private _bottomSheet: MatBottomSheet, ) { 
    
    this._bottomSheet.open(BottomSheetOverviewExampleSheet);
  }

  ngOnInit() {
  }

}

@Component({
  selector: 'bottom-sheet-overview-example-sheet',
  templateUrl: 'bottom-sheet-overview-example-sheet.html',
})
export class BottomSheetOverviewExampleSheet {
  message: any;
  constructor(private _bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewExampleSheet>) {
    this.message = localStorage.getItem('errorMessage');
  }

  openLink(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }
}